import { Input } from '@alifd/next';
import wrapper from './next-wrapper';
const ProFormInput = wrapper(Input, 'ProFormInput');
export default ProFormInput;
